import { useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { colors, spacing, typography } from "../../../../../../../../../assets/styles/tokens";

interface ViewingPaginationProps {
  total?: number;
  pageSize?: number;
}

export default function BudgetControlGraphPagination({
  total = 12,
  pageSize = 5,
}: ViewingPaginationProps) {
  const [page, setPage] = useState(1);

  const totalPages = Math.ceil(total / pageSize);
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  const handlePrev = () => setPage((p) => Math.max(1, p - 1));
  const handleNext = () => setPage((p) => Math.min(totalPages, p + 1));

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent:'center',
        alignItems: "center",
        py:spacing.Spacing.md1.$value
      }}
    >
      {/* Prev button */}
      <IconButton
        onClick={handlePrev}
        disabled={page === 1}
        size="small"
        sx={{
          color: page === 1 ? colors.GrayLightMode[500].$value : colors.GrayLightMode[700].$value,
          "&:hover": { backgroundColor: "transparent", color: colors.GrayLightMode[500].$value },
          p: 0.5,
        }}
      >
        <ChevronLeftIcon sx={{ fontSize: 18 }} />
      </IconButton>

      {/* Label */}
      <Box sx={{ textAlign: "center", minWidth: 72 }}>
        <Typography
          sx={{
            fontSize: typography.Size.Text.xs.$value,
            fontWeight: typography.Font_weight.Regular.$value,
            color: colors.GrayLightMode[500].$value,
          }}
        >
          Viewing
        </Typography>
        <Typography
          sx={{
             fontSize: typography.Size.Text.xs.$value,
            fontWeight: typography.Font_weight.Regular.$value,
            color: colors.GrayLightMode[500].$value,
          }}
        >
          {from}–{to} of {total}
        </Typography>
      </Box>

      {/* Next button */}
      <IconButton
        onClick={handleNext}
        disabled={page === totalPages}
        size="small"
        sx={{
          color: page === totalPages ? colors.GrayLightMode[500].$value : colors.GrayLightMode[700].$value,
          "&:hover": { backgroundColor: "transparent", color: colors.GrayLightMode[500].$value },
          p: 0.5,
        }}
      >
        <ChevronRightIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Box>
  );
}